import React, { useContext } from 'react'
import {dataContext,load,localestr} from '../utils.js'
import icon from '../icons_h.svg'
import icon2 from '../icons.svg'


function TabPanel({Tabs,ActiveTab,TabClick,TabClose,User,status,actions}){
  const context=useContext(dataContext)
  const usersettings=context.usersettings

  const items=Tabs.map(function(item,index){
    return <div  tabIndex='0' key={index} className={index===ActiveTab?'tabbuton active  no-print':'tabbuton  no-print'} role='button' 
    onKeyUp={(e)=>{if(e.key === 'Enter') TabClick(index);console.log(e);if(e.which === 120 || e.keyCode === 120) TabClose(index,ActiveTab)}} onClick={()=>{TabClick(index)}} >
    {localestr(item.caption)+(item.need_save?'*':'')}<div className='close no-print' onClick={(e)=>{e.preventDefault(); e.stopPropagation(); TabClose(index,ActiveTab)}} /></div>
  })

    const logoff = () => {
        if (User && usersettings) localStorage.setItem(User,JSON.stringify(usersettings))
        load("action=logoff",actions.setLogin)
    }

  let ofl=''
  if(status==='OffLine') ofl=<div className='toolBarIcon'><img className='toolBarIcon' src={icon+'#wifi'} alt='' /></div>

  return(
    <div style={{display:'flex',justifyContent:'space-between'}}>
      <div className='tabpanel no-print'>
        {items}
      </div>
      <div className='navbar no-print' style={{borderRadius:'16px 0 0 15px',padding:'0 2px 0 8px',fontSize:'small'}}>
        {User}
        {ofl}
        <div className='toolBarItem' onClick={logoff}><img className='toolBarIcon' src={icon2+'#log'} alt='' /></div>
      </div>
    </div>
  )
}
export default TabPanel